import 'core-js/modules/es.global-this.js';
import '../assets/external/stringResources.js';
import { convertObjectToString } from 'app/shared/utils/string.util';

import { Command } from 'commander';
import { CmdApiApp } from './services/cmd-api.app';

const program = new Command();

program
    .command('export <rootFolder> <factoryId> [outputFolder] [featureflags]')
    .description(stringResources.CmdApiExportTemplateDescription, {
        rootFolder: stringResources.CmdApiRootFolderDescription,
        factoryId: stringResources.CmdApiResourceIdDescription,
        outputFolder: stringResources.CmdApiOutputFolder,
        featureflags: stringResources.CmdApifeatureflags,
    })
    .option('--preview', stringResources.CmdApiPreview)
    .action(async (rootFolder, factoryId, outputFolder, featureflags, options) => {
        try {
            const usePreviewTools = !!options.preview;
            await CmdApiApp.initialize(rootFolder, factoryId, undefined, featureflags);
            CmdApiApp.resourcesLoaded.subscribe(async (resourcesLoaded) => {
                if (resourcesLoaded) {
                    try {
                        await CmdApiApp.exportArmTemplate(outputFolder, usePreviewTools);
                    } catch {
                        process.exit(-1);
                    }
                }
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(`Unexpected error during export template command: ${convertObjectToString(error)}`);
            throw error;
        }
    });

program
    .command('validate <rootFolder> <factoryId> [featureflags]')
    .description(stringResources.CmdApiValidateDescription, {
        rootFolder: stringResources.CmdApiRootFolderDescription,
        factoryId: stringResources.CmdApiResourceIdDescription,
        featureflags: stringResources.CmdApifeatureflags
    })
    .action(async (rootFolder, factoryId, featureflags) => {
        try {
            await CmdApiApp.initialize(rootFolder, factoryId, undefined, featureflags);
            CmdApiApp.resourcesLoaded.subscribe(async (resourcesLoaded) => {
                if (resourcesLoaded) {
                    try {
                        const violations = await CmdApiApp.validateResources();
                        if (violations.length > 0) {
                            process.exit(-1);
                        }
                    } catch {
                        process.exit(-1);
                    }
                }
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(`Unexpected error during resource validation: ${convertObjectToString(error)}`);
            throw error;
        }
    });

program.parse(process.argv);
